import LocalizationStore from '../Stores/LocalizationStore'
import UsersStore from '../Stores/UsersStore'

export interface IUserRole {
    roleName: string
}

export interface IUser {
    id: string
    activeDateTime: string
    lastLoginDateTime: string
    name: string
    email: string
    roles: Array<string>
    isActive: boolean
    password?: string
    confirmPassword?: string,
    isEmailConfirmed: boolean,
    lockoutEnabled: boolean,
    lockoutEnd: Date | null
}

export enum UserRoles {
    CreditConsultant = 'CreditConsultant',
    CreditExpert = 'CreditExpert',
    Administrator = 'Administrator',
    Caller = 'Caller',
    Collector = 'Collector',
    Lawyer = 'Lawyer',
    CreditGroupAdministrator = 'CreditGroupAdministrator',
    CollectionGroupAdministrator = 'CollectionGroupAdministrator',
    LogisticsAgent = 'LogisticsAgent',
    Cashier = 'Cashier',
    CashierAdmin = 'CashierAdmin',
    CatalogProductAdministrator = 'CatalogProductAdministrator',
    HardCaller = 'HardCaller',
    SuperAdmin = 'SuperAdmin'
}

export class User implements IUser {
    id: string
    activeDateTime: string
    lastLoginDateTime: string
    name: string
    email: string
    roles: Array<string>
    isActive: boolean
    password?: string
    confirmPassword?: string
    isEmailConfirmed: boolean
    lockoutEnabled: boolean
    lockoutEnd: Date | null

    constructor() {
        this.password = this.confirmPassword = UsersStore.getInstance().generateRandomPassword()
    }
}

const ls = LocalizationStore.getInstance()

export function getUserFormSchema(): any {
    return {
        'title': ls.t!('User'),
        'type': 'object',
        'required': [
            'name',
            'email',
            'password',
            'confirmPassword'
        ],
        'properties': {
            'name': {
                'name': ls.t!('userName'),
                'type': 'string'
            },
            'email': {
                'title': ls.t!('email'),
                'type': 'string'
            },
            'Password': {
                'title': ls.t!('Password'),
                'type': 'string'
            },
            'confirmPassword': {
                'title': ls.t!('confirmPassword'),
                'type': 'string'
            }
        }
    }
}

export const UIUserFormSchema = {
    'password': {
        'ui:widget': 'password'
    },
    'confirmPassword': {
        'ui:widget': 'password'
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/User.ts